import { render, staticRenderFns } from "./CardStatDiffEquipmentNavisionVsNavixy.vue?vue&type=template&id=a98f9736&"
import script from "./CardStatDiffEquipmentNavisionVsNavixy.vue?vue&type=script&lang=js&"
export * from "./CardStatDiffEquipmentNavisionVsNavixy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports